import React, { ReactElement } from 'react'
import { IEditionPublishing } from '../../types/pack'
import * as date from '../../services/date'
import { getPublishedDate } from '../../services/publishedGraphic'
import { StyledCallSplit, StyledFlexRow } from './styled'

interface IEditionStatus {
  publishing: IEditionPublishing
}

export const EditionStatus = ({
  publishing: { publishing, published, changed, locations },
}: IEditionStatus): ReactElement => (
  <StyledFlexRow>
    <StyledCallSplit error={!publishing && (!published || changed)} />
    {publishing
      ? 'Publishing'
      : published
      ? date.calendar(getPublishedDate(locations))
      : 'Not Published'}
  </StyledFlexRow>
)
